export default __webpack_public_path__ + "static/media/last-ten-seconds.32bb91b0.mp3";